import type { ComponentPropsWithRef } from "react";

import { cn } from "~/utils";

export function Button({ className, ...props }: ComponentPropsWithRef<"button">) {
  return (
    <button
      className={cn(
        "inline-flex min-h-12 cursor-pointer items-center justify-center rounded-md bg-brand px-5 py-3 text-sm font-semibold text-white transition-[filter,opacity] hover:brightness-95 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand active:brightness-90 disabled:cursor-not-allowed disabled:opacity-60",
        className,
      )}
      {...props}
    />
  );
}
